import { render, staticRenderFns } from "./swipe.vue?vue&type=template&id=c6b98966&scoped=true&"
import script from "./swipe.vue?vue&type=script&lang=js&"
export * from "./swipe.vue?vue&type=script&lang=js&"
import style0 from "./swipe.vue?vue&type=style&index=0&id=c6b98966&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b98966",
  null
  
)

export default component.exports